import React, { useState, useEffect } from "react";
import { Link, useNavigate } from "react-router-dom";
import { useForm } from "react-hook-form";
import useAuthStore from "../store/authStore";
import axios from "axios";
import "./Auth.css";

const Login = () => {
  const {
    register,
    handleSubmit,
    formState: { errors },
  } = useForm();
  const [loading, setLoading] = useState(false);
  const [errorMessage, setErrorMessage] = useState("");
  const navigate = useNavigate();
  const { login, isAuthenticated } = useAuthStore();
  const API_URL = process.env.REACT_APP_BASE_URL || "http://localhost:3337";

  useEffect(() => {
    if (isAuthenticated) navigate("/");
  }, [isAuthenticated, navigate]);

  const onSubmit = async (data) => {
    setLoading(true);
    setErrorMessage("");

    try {
      const response = await axios.post(`${API_URL}/api/users/signin`, data);
      if (response.data.message === "success") {
        login(
          response.data.user.email,
          response.data.user.role,
          response.data.token
        );
        navigate("/");
      }
    } catch (error) {
      setErrorMessage(
        error.response?.data?.message || "Erreur lors de la connexion."
      );
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="auth-page">
      <div className="auth-card">
        {/* Logo */}
        <div className="auth-card__logo">
          <img src="/bouchaddakh-logo.png" alt="BOUCHADDAKH" />
        </div>

        {/* Header */}
        <div className="auth-card__header">
          <h1 className="auth-card__title">Connexion</h1>
          <p className="auth-card__subtitle">
            Accédez à votre espace client BOUCHADDAKH
          </p>
        </div>

        {/* Error */}
        {errorMessage && (
          <div className="auth-alert auth-alert--error">{errorMessage}</div>
        )}

        {/* Form */}
        <form onSubmit={handleSubmit(onSubmit)}>
          <div className="auth-field">
            <label className="auth-field__label">Email</label>
            <input
              type="email"
              className={`auth-field__input ${errors.email ? "auth-field__input--error" : ""}`}
              placeholder="votre@email.com"
              {...register("email", { required: "Email requis" })}
            />
            {errors.email && (
              <p className="auth-field__error">{errors.email.message}</p>
            )}
          </div>

          <div className="auth-field">
            <label className="auth-field__label">Mot de passe</label>
            <input
              type="password"
              className={`auth-field__input ${errors.password ? "auth-field__input--error" : ""}`}
              placeholder="••••••••"
              {...register("password", { required: "Mot de passe requis" })}
            />
            {errors.password && (
              <p className="auth-field__error">{errors.password.message}</p>
            )}
          </div>

          <div className="auth-forgot">
            <Link to="/forgot-password">Mot de passe oublié ?</Link>
          </div>

          <button type="submit" className="auth-submit" disabled={loading}>
            {loading ? (
              <>
                <span className="auth-spinner" />
                Connexion...
              </>
            ) : (
              "Se connecter →"
            )}
          </button>
        </form>

        {/* Footer */}
        <div className="auth-card__footer">
          <span>Pas encore de compte ? </span>
          <Link to="/signup">Créer un compte</Link>
        </div>
      </div>
    </div>
  );
};

export default Login;
